import React from 'react';

export default props => (
    <svg viewBox="0 0 34 34" {...props}>
        <path fill="#BBC0CB" fillRule="evenodd"
              d="M19.753 9a1.358 1.358 0 0 1 .966 2.314l-5.45 5.511 5.45 5.512a1.358 1.358 0 1 1-1.933 1.91l-6.394-6.466a1.358 1.358 0 0 1 0-1.91l6.394-6.468c.266-.268.616-.403.967-.403"/>
    </svg>
);